module.exports = __webpack_public_path__ + "static/media/DSC01436.33ee2178.jpg";